module.exports = __webpack_public_path__ + "static/img/pic_rjyf_rjys_ysmx@2x.a0335b62.png";